import { render } from "./detailStage.vue?vue&type=template&id=b017da2e&scoped=true"
import script from "./detailStage.js?vue&type=script&lang=js"
export * from "./detailStage.js?vue&type=script&lang=js"

import "./detailStage.vue?vue&type=style&index=0&id=b017da2e&scoped=true&lang=scss"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b017da2e"]])

export default __exports__